import React from 'react';

/**
 * Assegnando questo simbolo ad un componente React, è possibile
 * identificare se un elemento è un Input Checkbox booleano.
 * In questo modo è possibile eliminare l'asterisco rosso di richiesto
 * nel FormItem che nel caso specifico ha poco senso.
 */
export const IsBooleanCheckboxElementSymbol = '__IsBooleanCheckboxElement';

/**
 * Verifica se l'elemento passato è un RadioGroupElement.
 */
export function isBooleanCheckboxElement(element: React.ReactNode) {
  return (
    React.isValidElement(element) &&
    typeof element.type !== 'string' &&
    IsBooleanCheckboxElementSymbol in element.type &&
    element.type?.[IsBooleanCheckboxElementSymbol] === true
  );
}
